import store from "@/store"
import _, { multiply, round } from "lodash"

const r = {
	imgMorenUrl() {
		let r = ""
		switch (process.env.NODE_ENV) {
			case "development":
				r = "images/ORG_LOGO_IMG/3e0cf30579ac403b888ac018b9824579.png"
				break
			case "production":
				if (window.location.host === "test.rongdaufun.com") {
					r = "images/ORG_LOGO_IMG/3e0cf30579ac403b888ac018b9824579.png"
				} else {
					r = "images/ORG_LOGO_IMG/b63f87d013ff417ba8d8e7e0ece74d44.png"
				}

				break
			default:
				break
		}
		return r
	},

	search2params(search) {
		let params = {}
		try {
			params = search.replace("?", "").split("&").reduce((obj, curr) => {
				let [key, value] = curr.split("=")
				obj[key] = value
				return obj
			}, {})
		} catch (error) {
			console.log("解析地址query参数错误：", error)
		}
		return params
	},

	// 转换图片的路径为全路径
	fullImage(src) {
		let r = src
		switch (process.env.NODE_ENV) {
			case "development":
				r = "https://tcdn.rongdaufun.com/" + r + "?imageslim"
				break
			case "production":
				let baseurl = "https://cdn.rongdaufun.com/"
				if (window.location.host === "test.rongdaufun.com") {
					baseurl = "https://tcdn.rongdaufun.com/"
				}
				r = baseurl + r + "?imageslim"
				break
			default:
				break
		}
		return r
	},

	// 把数字转换成精确到小数点后两位
	toFixed2(total) {
		if (isNaN(parseFloat(total))) {
			return total
		}
		return ((parseFloat(_.ceil(_.round(total, 2))) || 0) / 100).toFixed(2)
	},
	mulitplInit(val, rate = 100) {
		if (isNaN(parseFloat(val))) {
			return val
		}
		return round(multiply(val, 100))
	},
	// 把数字转换成逗号分隔的格式
	sepNum(total, digit) {
		let aStr = (total + "").split(".")
		let str = aStr[0]
		let digitStr = ""
		if (aStr.length > 1) {
			digitStr = aStr[1]
		}

		let startIndex = str.length % digit
		let list = []
		if (startIndex > 0) {
			list.push(str.substring(0, startIndex))
		}
		for (let i = startIndex; i < str.length; i += digit) {
			list.push(str.substring(i, i + digit))
		}

		if (digitStr) {
			return list.join(", ") + "." + digitStr
		} else {
			return list.join(", ")
		}
	},
	// 判断权限
	testAuthorityPath(pathUrl = "") {
		const pathList = store.getState()?.sysuserInfo?.pathList ?? []
		if (pathUrl) {
			return pathList.includes(pathUrl)
		} else {
			return false
		}
	},
	// 清空对象中值为null, undefined ""的属性
	clearParamsEmptyValue(obj = {}) {
		if (typeof obj !== "object" || _.isEmpty(obj)) {//只处理object
			return obj
		}
		let keys = Object.keys(obj)
		let notEmptykey = _.filter(keys, (key) => !this.isEmptyFun(obj[key]))
		let newObj = {}
		if (!(notEmptykey && notEmptykey.length > 0)) { //传入的对象值都为空，返回空对象
			return newObj
		}
		notEmptykey.forEach((key) => {
			let _val = obj[key]
			if (Array.isArray(_val) && _val?.length > 0) { // 当前值数组
				newObj[key] = _val.map((item) => {
					return this.clearParamsEmptyValue(item)
				})
				return newObj[key]
			}
			if (typeof _val == "object" && !Array.isArray(_val) && _val !== null) { // 当前值对象
				return newObj[key] = this.clearParamsEmptyValue(_val)
			}
			return newObj[key] = _val
		})
		return newObj
	},
	// 判断是否是 null, undefined ""
	isEmptyFun(val) {
		return [undefined, null, ""].includes(val)
	},
	// 两位小数的正则判断
	testNum(val) {
		if (val === "") {
			return true
		} else {
			let reg = /^(([1-9]\d*)|0)(\.\d{0,2})?$/
			return reg.test(val)
		}
	},
	// 计算占用字符
	computedChar(str = "") {
		let totalLength = 0
		let i
		let charCode
		for (i = 0; i < str.length; i++) {
			charCode = str.charCodeAt(i)
			if (charCode < 0x007f) {
				totalLength = totalLength + 1
			} else {
				totalLength += 2
			}
		}
		return totalLength
	},
}

export default r
